import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation, .navigation-logo, .navigation-link, .navigation-cta, .navigation-toggle, .navigation-mobile-close, .navigation-logo-icon {
  transition: none;
  animation: none;
}
.navigation-mobile-item {
  opacity: 1;
  transform: none;
  animation: none;
}
.navigation-link:hover, .navigation-logo:hover, .navigation-cta:hover {
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <nav className="navigation">
        <div className="navigation-container">
          <a href="#" id="navigationLogo">
            <div className="navigation-logo">
              <svg
                width="32"
                xmlns="http://www.w3.org/2000/svg"
                height="32"
                viewBox="0 0 24 24"
                className="navigation-logo-icon"
              >
                <path
                  d="M21 16.008V7.99a1.98 1.98 0 0 0-1-1.717l-7-4.008a2.02 2.02 0 0 0-2 0L4 6.273c-.619.355-1 1.01-1 1.718v8.018c0 .709.381 1.363 1 1.717l7 4.008a2.02 2.02 0 0 0 2 0l7-4.008c.619-.355 1-1.01 1-1.718M12 22V12m0 0l8.73-5.04m-17.46 0L12 12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span className="section-title">SilkTech</span>
            </div>
          </a>
          <ul className="navigation-links">
            <li>
              <a href="#">
                <div className="navigation-link">
                  <span>Services</span>
                </div>
              </a>
            </li>
            <li>
              <a href="#">
                <div className="navigation-link">
                  <span>Portfolio</span>
                </div>
              </a>
            </li>
            <li>
              <a href="#">
                <div className="navigation-link">
                  <span>Technology</span>
                </div>
              </a>
            </li>
            <li>
              <a href="#">
                <div className="navigation-link">
                  <span>About</span>
                </div>
              </a>
            </li>
            <li>
              <a href="#">
                <div className="navigation-link">
                  <span>Contact</span>
                </div>
              </a>
            </li>
          </ul>
          <button className="navigation-cta btn btn-primary">
            Get Started
          </button>
          <button
            id="navigationToggle"
            aria-label="Toggle navigation"
            aria-expanded="false"
            className="navigation-toggle"
          >
            <svg
              width="28"
              xmlns="http://www.w3.org/2000/svg"
              height="28"
              viewBox="0 0 24 24"
            >
              <path
                d="M4 5h16M4 12h16M4 19h16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
        <canvas
          id="navigationParticles"
          className="navigation-particles"
        ></canvas>
      </nav>
      <div id="navigationMobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-mobile-header">
          <a href="#">
            <div className="navigation-mobile-logo">
              <svg
                width="32"
                xmlns="http://www.w3.org/2000/svg"
                height="32"
                viewBox="0 0 24 24"
                className="navigation-logo-icon"
              >
                <path
                  d="M21 16.008V7.99a1.98 1.98 0 0 0-1-1.717l-7-4.008a2.02 2.02 0 0 0-2 0L4 6.273c-.619.355-1 1.01-1 1.718v8.018c0 .709.381 1.363 1 1.717l7 4.008a2.02 2.02 0 0 0 2 0l7-4.008c.619-.355 1-1.01 1-1.718M12 22V12m0 0l8.73-5.04m-17.46 0L12 12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span className="section-title">NeonFlux</span>
            </div>
          </a>
          <button
            id="navigationMobileClose"
            aria-label="Close navigation"
            className="navigation-mobile-close"
          >
            <svg
              width="32"
              xmlns="http://www.w3.org/2000/svg"
              height="32"
              viewBox="0 0 24 24"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
        <ul className="navigation-mobile-links">
          <li className="navigation-mobile-item">
            <a href="#">
              <div className="navigation-mobile-link">
                <span>Services</span>
              </div>
            </a>
          </li>
          <li className="navigation-mobile-item">
            <a href="#">
              <div className="navigation-mobile-link">
                <span>Portfolio</span>
              </div>
            </a>
          </li>
          <li className="navigation-mobile-item">
            <a href="#">
              <div className="navigation-mobile-link">
                <span>Technology</span>
              </div>
            </a>
          </li>
          <li className="navigation-mobile-item">
            <a href="#">
              <div className="navigation-mobile-link">
                <span>About</span>
              </div>
            </a>
          </li>
          <li className="navigation-mobile-item">
            <a href="#">
              <div className="navigation-mobile-link">
                <span>Contact</span>
              </div>
            </a>
          </li>
        </ul>
        <button className="btn-lg navigation-mobile-cta btn btn-primary">
          Get Started
        </button>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<style>
        @keyframes slideInLeft {to {opacity: 1;
transform: translateX(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="navigation-container6">
        <div className="navigation-container7">
          <Script
            html={`<script defer data-name="navigation-interactions">
(function(){
  const navigationToggle = document.getElementById("navigationToggle")
  const navigationMobileOverlay = document.getElementById("navigationMobileOverlay")
  const navigationMobileClose = document.getElementById("navigationMobileClose")
  const navigationLogo = document.getElementById("navigationLogo")
  const canvas = document.getElementById("navigationParticles")
  const ctx = canvas.getContext("2d")

  let particles = []
  let animationId

  function initCanvas() {
    const nav = document.querySelector(".navigation")
    canvas.width = nav.offsetWidth
    canvas.height = nav.offsetHeight
  }

  class Particle {
    constructor() {
      this.reset()
    }

    reset() {
      this.x = Math.random() * canvas.width
      this.y = Math.random() * canvas.height
      this.vx = (Math.random() - 0.5) * 0.5
      this.vy = (Math.random() - 0.5) * 0.5
      this.radius = Math.random() * 2 + 1
      this.opacity = Math.random() * 0.5 + 0.2
    }

    update() {
      this.x += this.vx
      this.y += this.vy

      if (this.x < 0 || this.x > canvas.width) this.vx *= -1
      if (this.y < 0 || this.y > canvas.height) this.vy *= -1
    }

    draw() {
      ctx.beginPath()
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2)
      ctx.fillStyle = \`rgba(74, 144, 226, \${this.opacity})\`
      ctx.fill()
    }
  }

  function initParticles() {
    particles = []
    for (let i = 0; i < 30; i++) {
      particles.push(new Particle())
    }
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    particles.forEach((particle) => {
      particle.update()
      particle.draw()
    })

    particles.forEach((p1, i) => {
      particles.slice(i + 1).forEach((p2) => {
        const dx = p1.x - p2.x
        const dy = p1.y - p2.y
        const distance = Math.sqrt(dx * dx + dy * dy)

        if (distance < 100) {
          ctx.beginPath()
          ctx.moveTo(p1.x, p1.y)
          ctx.lineTo(p2.x, p2.y)
          ctx.strokeStyle = \`rgba(74, 144, 226, \${0.15 * (1 - distance / 100)})\`
          ctx.lineWidth = 1
          ctx.stroke()
        }
      })
    })

    animationId = requestAnimationFrame(animate)
  }

  navigationToggle.addEventListener("click", () => {
    navigationMobileOverlay.classList.add("active")
    navigationToggle.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"
  })

  navigationMobileClose.addEventListener("click", () => {
    navigationMobileOverlay.classList.remove("active")
    navigationToggle.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
  })

  navigationMobileOverlay.querySelectorAll(".navigation-mobile-link").forEach((link) => {
    link.addEventListener("click", () => {
      navigationMobileOverlay.classList.remove("active")
      navigationToggle.setAttribute("aria-expanded", "false")
      document.body.style.overflow = ""
    })
  })

  let logoRotation = { x: 0, y: 0 }
  navigationLogo.addEventListener("mousemove", (e) => {
    const rect = navigationLogo.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top
    const centerX = rect.width / 2
    const centerY = rect.height / 2

    logoRotation.x = (y - centerY) / 10
    logoRotation.y = (centerX - x) / 10

    navigationLogo.style.transform = \`perspective(1000px) rotateX(\${logoRotation.x}deg) rotateY(\${logoRotation.y}deg) translateY(-2px)\`
  })

  navigationLogo.addEventListener("mouseleave", () => {
    navigationLogo.style.transform = ""
  })

  window.addEventListener("resize", () => {
    initCanvas()
  })

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    canvas.style.display = "none"
  } else {
    initCanvas()
    initParticles()
    animate()
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
